import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AsociacionPage } from 'src/app/domain/model/asociacion-empleado/asociacion-empleado';

/**
 * Adaptador HTTP genérico de los catálogos de selección (Fase 2.5,
 * HU1259149) usados por el picker de "agregar": Servicios, Especialidades,
 * Detalles de Zona, Unidades de Negocio de un cliente. Endpoints:
 * `/api/servicios/catalogos/{recurso}`.
 *
 * <p>Categorías Cliente NO usa este servicio — reutiliza
 * {@code CategoriaClienteRepository} ya existente (lista plana, sin
 * paginación cursor), ver Fase 2.5, HU1259149.md.</p>
 *
 * <p>Mismo criterio que {@link HttpAsociacionEmpleadoService}: un
 * {@code recurso} + filtros por query param en vez de 4 clases repositorio
 * separadas — ver justificación de DI genérica en ese archivo.</p>
 */
@Injectable({ providedIn: 'root' })
export class HttpCatalogoSeleccionService {

  private readonly http = inject(HttpClient);

  async buscar<T>(
    recurso: string,
    filtros: Record<string, string | number | undefined | null>,
    size: number,
    cursor?: string,
    direction?: 'NEXT' | 'PREVIOUS'
  ): Promise<AsociacionPage<T>> {
    let params = new HttpParams().set('size', size.toString());
    if (cursor?.trim()) params = params.set('cursor', cursor.trim());
    if (direction) params = params.set('direction', direction);

    for (const [clave, valor] of Object.entries(filtros)) {
      if (valor !== undefined && valor !== null && `${valor}`.trim() !== '') {
        params = params.set(clave, `${valor}`.trim());
      }
    }

    return firstValueFrom(
      this.http.get<AsociacionPage<T>>(`${environment.backend.baseUrl}/servicios/catalogos/${recurso}`, { params })
    );
  }
}
